import { tv } from "@/utils/tv.config";
import { VariantProps } from "tailwind-variants";

export const cardClasses = tv({
  base: ["Card__Root shadow-md", "p-0", "rounded-xl"],
  variants: {
    outlined: {
      true: ["border", "border-gray-300", "shadow-none"],
    },
  },
});

export type CardVariants = VariantProps<typeof cardClasses>;
